import goToSearch from './go-to-search'
import { mapActions, mapGetters, mapMutations, } from 'vuex'
import { SET_HEIGHT_OF_TBODY, } from '../store/modules/search/mutations-types'

export default {
  mixins: [ goToSearch, ],
  methods: {
    ...mapActions('search', [ 'searchWithParams', ]),
    ...mapMutations('search', {
      setHeight: SET_HEIGHT_OF_TBODY,
    }),
    routerSearch (hash = '#search-form') {
      if (this.paramsForURL !== this.$route.params.search) {
        this.calcHeightOfTableBody()
        this.$router.push({
          name: 'Search',
          params: { search: this.paramsForURL, },
          hash,
        }, this.goToSearchPage(hash))
        this.searchWithParams()
      }
    },
    calcHeightOfTableBody () {
      const tBody = document.getElementById('tbody')
      this.setHeight(tBody ? tBody.offsetHeight + 30 : 300)
    },
  },
  computed: {
    ...mapGetters('search', [ 'paramsForURL', ]),
  },
}



// WEBPACK FOOTER //
// ./src/mixins/router-search-mixin.js